import {
  generatePath,
  Outlet,
  useNavigate,
  useParams,
  useLocation,
} from 'react-router-dom';
import { useEffect } from 'react';
import {
  ButtonSecondary,
  Tabs,
  PermissionEnum,
  PermissionDenied,
  IconLoader,
} from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import { clearMarginListState } from './store/slices/list';

import ROUTES from '../../routes';

import cn from './styles.module.css';

const Margins = (): React.JSX.Element => {
  const {
    exchangeDictionaries: { activePermissions, currencies },
  } = useAppSelector((state) => state);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { currency } = useParams();
  const { search } = useLocation();

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions.includes(
        PermissionEnum.SETTINGS_EXCHANGE_MARGINS_LIST,
      ) &&
      currencies?.length &&
      !currency
    ) {
      navigate(
        generatePath(ROUTES.MARGINS_CURRENCY, {
          currency: currencies[0]?.id,
        }),
      );
    }
  }, [currencies, activePermissions, currency]);

  useEffect(
    () => () => {
      dispatch(clearMarginListState());
    },
    [],
  );

  useEffect(() => {
    let title = 'Exchange margins';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.marginsLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      activePermissions?.includes(PermissionEnum.SETTINGS_EXCHANGE_MARGINS_LIST)
    ) {
      content = (
        <div className={cn.margins}>
          <div className={cn.marginsTopWrapper}>
            <div className={cn.marginsTitle}>Exchange margins</div>
            {currencies && currencies?.length && (
              <div className={cn.marginsControlRow}>
                <Tabs
                  tabs={currencies?.slice(0, 7).map((item) => ({
                    name: item.name,
                    path: `${generatePath(ROUTES.MARGINS_CURRENCY, {
                      currency: item.id,
                    })}${search || ''}`,
                  }))}
                  hiddenRoutes={currencies?.slice(7).map((item) => ({
                    name: item.name,
                    path: `${generatePath(ROUTES.MARGINS_CURRENCY, {
                      currency: item.id,
                    })}${search || ''}`,
                  }))}
                  wrapperClassName={cn.tabsWrapper}
                  itemClassName={cn.tabsItem}
                  enableRouting
                />
                {activePermissions?.includes(
                  PermissionEnum.SETTINGS_EXCHANGE_EDIT_MARGINS_ACTION,
                ) && (
                  <ButtonSecondary
                    text="Set a fees for all"
                    onClick={() => {
                      const url = generatePath(ROUTES.MARGIN_INFO, {
                        currency: currency as string,
                        marginId: 'all',
                      });
                      navigate(`${url}${search || ''}`);
                    }}
                    bold
                  />
                )}
              </div>
            )}
          </div>
          <Outlet />
        </div>
      );
    } else {
      content = <PermissionDenied />;
    }
  }

  return content;
};
export default Margins;
